<div class="content-wrapper">
  <app-verify-email-notification
    *ngIf="isAccountNotified$ | async"
    class="verify-account-notification"
    [message]="'VERIFY_ACCOUNT.DEFAULT_VERIFY_NOTIFICATION' | translate"
    [trackingScreenName]="trackingScreenName"
  >
  </app-verify-email-notification>
  <app-renderer
    [documentDataDispatcher]="documentDataDispatcher"
    [enableBankTransfer]="bankTransferEnabled$ | async"
    [enableCardPayments]="cardPaymentsEnabled$ | async"
    [enablePaypal]="paypalEcEnabled$ | async"
    [viewableAsPdf]="true"
    [paymentsSettings]="paymentsSettings$ | async"
    [renderableEntity]="document$ | async"
    [featureToggles]="featureToggles"
    [trackingObject]="documentTrackingObject$ | async"
    [trackingScreenName]="trackingScreenName"
    (onReRenderPdf)="removeSignatures()"
  >
  </app-renderer>
</div>

<div class="aside-wrapper">
  <ng-container *ngIf="document$ | async as document; else placeholder">
    <app-aside-actions
      [documentDataDispatcher]="documentDataDispatcher"
      [document]="document"
      [documentHasUnsavedChanges]="documentHasUnsavedChanges$ | async"
      [documentType]="documentType$ | async"
      [documentId]="documentId$ | async"
      [documentNumber]="documentNumber$ | async"
      [documentState]="documentState$ | async"
      [documentCalculationResult]="documentCalculationResult$ | async"
      [documentSettings]="documentSettings$ | async"
      [documentPayments]="documentPayments$ | async"
      [documentBilling]="documentBilling$ | async"
      [documentPaymentUrl]="documentPaymentUrl$ | async"
      [documentDate]="documentDate$ | async"
      [documentFeatureName]="documentFeatureName$ | async"
      [documentDueDate]="documentDueDate$ | async"
      [documentSchedule]="documentSchedule$ | async"
      [documentRevisionId]="documentRevisionId$ | async"
      [sourceDocumentPreview]="sourceDocumentPreview$ | async"
      [linkedDocumentPreview]="linkedDocumentPreview$ | async"
      [documentTrackingObject]="documentTrackingObject$ | async"
      [showPaid]="showPaid"
      [showTotal]="showTotal"
      [useOutstandingBalance]="useOutstandingBalance"
      [showPaymentReminders]="showPaymentReminders"
      [showPaymentActions]="showPaymentActions"
      [showI2gMoney]="showI2gMoney"
      [showBankTransfer]="showBankTransfer$ | async"
      [showCardPayments]="showCardPayments$ | async"
      [showPaypalEc]="showPaypalEc$ | async"
      [paypalEcStatus]="paypalEcStatus$ | async"
      [i2gMoneyEnabled]="i2gMoneyEnabled$ | async"
      [bankTransferEnabled]="bankTransferEnabled$ | async"
      [cardPaymentsEnabled]="cardPaymentsEnabled$ | async"
      [paypalEcEnabled]="paypalEcEnabled$ | async"
      [enableSchedules]="enableSchedules"
      [paymentsSettings]="paymentsSettings$ | async"
      [underwritingUrl]="underwritingUrl$ | async"
      [companySettings]="companySettings$ | async"
      [remindersSettings]="remindersSettings$ | async"
      [trackingScreenName]="trackingScreenName"
      [featureToggles]="featureToggles"
      [account]="account"
      [deposit]="deposit$ | async"
      [addDepositForFuture]="addDepositForFuture$ | async"
      [enableDeposits]="enableDeposits"
      [depositRequestFeatureName]="depositRequestFeatureName"
      (updateRecurringSchedule)="onUpdateRecurringSchedule($event)"
      (growthCta)="setInTmpCache()"
      (updateDocumentContent)="updateDocumentContent($event)"
      (updateSettingsContent)="updateSettingsContent($event)"
    >
    </app-aside-actions>
  </ng-container>

  <ng-template #placeholder>
    <app-placeholder-aside></app-placeholder-aside>
  </ng-template>
</div>
